"use client"

import { useEffect } from "react"

function shouldDisableServiceWorker(): boolean {
  if (process.env.NODE_ENV === "development") return true
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === "development") return true
  if (typeof window !== "undefined") {
    const host = window.location.hostname
    if (host.includes("-development-") || host.includes(".localhost")) return true
  }
  return false
}

/**
 * Registers `/sw.js` so Chromium treats the site as an installable PWA
 * (manifest alone is not enough — a fetch handler is required).
 * Disabled on dev hosts and unregisters stale workers (avoids broken fetch passthrough).
 */
export default function RegisterServiceWorker() {
  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return

    if (shouldDisableServiceWorker()) {
      void navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          void registration.unregister()
        }
      })
      return
    }

    void navigator.serviceWorker.register("/sw.js").catch(() => {
      /* ignore: private mode / blocked SW */
    })
  }, [])

  return null
}
